import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TranslateModule} from '@ngx-translate/core';
import {PipesModule} from "@pipes/Pipes.module";

import {EvaluacionErpComponent} from "./erp/evaluacionerp.component";
import {EvaluacionEmailComponent} from './email/evaluacionemail.component';
import {SeguridadService} from '../../Servicios/Seguridad.service';
import { GlobalModule } from '@contenido/AppContent/global/global.module';
import { ComponentesModule } from '@componentes/Componentes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { DxBulletModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxListModule, DxLoadPanelModule, DxSelectBoxModule, DxTreeViewModule, DxValidationSummaryModule, DxValidatorModule } from 'devextreme-angular';


export const routes =
    [
        {path: 'erp/:token', component: EvaluacionErpComponent, data: {modulo: 'externo'}, canActivate: [SeguridadService]},
        {path: 'email/:token', component: EvaluacionEmailComponent, data: {modulo: 'externo'}, canActivate: [SeguridadService]},
        {path: '**', redirectTo: '', pathMatch: 'full'},
    ];

@NgModule(
    {
        declarations:
            [
                EvaluacionErpComponent,
                EvaluacionEmailComponent,
            ],
        imports:
            [
                CommonModule,
                ComponentesModule,
                MatTooltipModule,
                MatTabsModule,
                DxDataGridModule,
                DxCheckBoxModule,
                DxSelectBoxModule,
                DxValidationSummaryModule,
                DxButtonModule,
                DxValidatorModule,
                DxBulletModule,
                DxLoadPanelModule,
                DxTreeViewModule,
                DxListModule,
                FormsModule,
                ReactiveFormsModule,
                RouterModule.forChild(routes),
                ModalModule.forRoot(),
                AngularSvgIconModule,
                TranslateModule,
                PipesModule,
                GlobalModule,
            ]
    })

export class EvaluacionExternoModule {
    static routes = routes;
}

